import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

let escapeListener = null;

const $format = unwrapFunctionStore(format);

export const optionChoice = {
  element: '.modal-content',
  popover: {
    title: $format('label.TOURS.STUDIO.CREATE.OPTIONS.CHOICE.TITLE'),
    description: $format('label.TOURS.STUDIO.CREATE.OPTIONS.CHOICE.DESCRIPTION'),
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const closeButton = document.querySelector('.close');

      escapeListener = (event) => {
        if (event.key === 'Escape') {
          if (closeButton) {
            closeButton.click();
          }
          document.removeEventListener('keydown', escapeListener);
        }
      };

      document.addEventListener('keydown', escapeListener);
    },
    onPrevClick: () => {
      const closeButton = document.querySelector('.close');

      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      if (closeButton) {
        closeButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 200);
      }
    },
    onNextClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.moveNext();
    }
  }
};

export const blankSignature = {
  element: '#blank-sig',
  popover: {
    title: $format('label.TOURS.STUDIO.CREATE.OPTIONS.BLANK.TITLE'),
    description: $format('label.TOURS.STUDIO.CREATE.OPTIONS.BLANK.DESCRIPTION'),
    side: 'bottom',
    align: 'center',
    onPopoverRender: () => {
      const closeButton = document.querySelector('.close');

      escapeListener = (event) => {
        if (event.key === 'Escape') {
          if (closeButton) {
            closeButton.click();
          }
          document.removeEventListener('keydown', escapeListener);
        }
      };

      document.addEventListener('keydown', escapeListener);
    },
    onPrevClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.movePrevious();
    },
    onNextClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.moveNext();
    }
  }
};

export const templateSignature = {
  element: '#sig-template',
  popover: {
    title: $format('label.TOURS.STUDIO.CREATE.OPTIONS.TEMPLATE.TITLE'),
    description: $format('label.TOURS.STUDIO.CREATE.OPTIONS.TEMPLATE.DESCRIPTION'),
    side: 'bottom',
    align: 'center',
    onPopoverRender: () => {
      const closeButton = document.querySelector('.close');

      escapeListener = (event) => {
        if (event.key === 'Escape') {
          if (closeButton) {
            closeButton.click();
          }
          document.removeEventListener('keydown', escapeListener);
        }
      };

      document.addEventListener('keydown', escapeListener);
    },
    onPrevClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.movePrevious();
    },
    onNextClick: () => {
      const sigTemplate = document.querySelector('#sig-template');

      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      if (sigTemplate) {
        sigTemplate.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};

export const osDesginSignature = {
  element: '#os-design',
  popover: {
    title: $format('label.TOURS.STUDIO.CREATE.OPTIONS.OS.TITLE'),
    description: $format('label.TOURS.STUDIO.CREATE.OPTIONS.OS.DESCRIPTION'),
    side: 'bottom',
    align: 'center',
    onPopoverRender: () => {
      const closeButton = document.querySelector('.close');

      escapeListener = (event) => {
        if (event.key === 'Escape') {
          if (closeButton) {
            closeButton.click();
          }
          document.removeEventListener('keydown', escapeListener);
        }
      };

      document.addEventListener('keydown', escapeListener);
    },
    onPrevClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.movePrevious();
    },
    onNextClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.moveNext();
    }
  }
};
